import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { AddExpenseForm } from './components/AddExpenseForm';
import { useLanguage } from '../../contexts/LanguageContext';

export default function AddExpensePage() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('/expenses');
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Button variant="outline" size="sm" asChild className="border-slate-200">
              <Link to="/expenses">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('expense.backToExpenses')}
              </Link>
            </Button>
            <div>
              <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('expense.addTitle')}</h1>
              <p className="text-slate-500 text-sm mt-0.5">{t('expense.addDesc')}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <AddExpenseForm onSuccess={handleSuccess} />
      </main>
    </div>
  );
}
